import React from "react"
import { Link } from "gatsby"
import { connector, ContainerProps } from "./containers/Header.container"

export type HeaderProps = {
  canPublish: boolean
  onPublish: Function
  from?: string | null
}

export const HeaderWrapper: React.FC<HeaderProps> = ({
  canPublish,
  onPublish,
  from
}) => {
  const buttonStyleNoContent =
    "cursor-not-allowed hover:animate-headShake focus:animate-headShake hover:text-red-400 focus:text-red-400 text-gray-300"
  const buttonStyleWithContent = "text-green-500"

  return (
    <nav className="flex items-center w-full h-16">
      <div className="container px-6 mx-auto">
        <div className="flex">
          <div className="flex items-center">
            <Link
              to={from || "/"}
              className="p-2 -ml-4 text-gray-400 transition-colors duration-300 ease-out rounded hover:bg-gray-200 hover:text-gray-800"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </Link>
          </div>

          <div className="flex ml-auto">
            <button
              onClick={() => onPublish()}
              className={`${canPublish && buttonStyleWithContent} ${
                !canPublish && buttonStyleNoContent
              } uppercase p-2 px-4 -mr-4 transition-colors duration-300 rounded`}
              aria-label="toggle menu"
            >
              Publier
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}

export const HeaderContainer: React.FC<ContainerProps> = props => (
  <HeaderWrapper {...props} />
)

export const Header = connector(HeaderContainer)
